import { RedoMerchantClient } from "@redotech/redo-merchant-app-common/client";

/**
 * Represents a TikTok integration for a merchant
 */
export interface TiktokIntegration {
  _id: string;
  kind: "Tiktok";
  team: string;
  accessToken: string;
  expiresIn?: number;
  refreshToken: string;
  refreshTokenExpiresIn?: number;
  shopId: string;
  sellerName: string;
  sellerRegion: string;
  cipher: string;
  createdAt?: string;
  updatedAt?: string;
}

/**
 * Response structure for the getTiktokIntegration API
 */
export interface GetTiktokIntegrationResponse {
  integration: TiktokIntegration | null;
}

export async function getTiktokIntegration(
  client: RedoMerchantClient,
  { signal }: { signal?: AbortSignal } = {},
): Promise<GetTiktokIntegrationResponse> {
  const response = await client.client.get("support/tiktok", {
    headers: client.authorization(),
    signal,
  });
  return response.data;
}

export async function deleteTiktokIntegration(
  client: RedoMerchantClient,
  { integrationId }: { integrationId: string },
): Promise<boolean> {
  const response = await client.client.delete(
    `support/tiktok/${integrationId}`,
    { headers: client.authorization() },
  );
  return response.data === "true";
}
